import {Injectable} from '@angular/core';

@Injectable()
export class UserEventsProvider {

    public data: Array<{}> = new Array<{}>();

    constructor() {
        let events = new Array<{}>();
        events.push({date: "2018-03-13", title: "Office", subtitle: "08:00 - 16:00 (12:00-13:00)", color: "violet"});
        events.push({
            date: "2018-03-13",
            title: "Extra nightshift",
            subtitle: "16:00 - 20:00 (18:00-18:15)",
            color: "orange"
        });
        this.data.push({
            user_id: "3333333333",
            events: events
        });
    }

    /**
     * @method getData
     * @returns {Promise<any>}
     */
    public getData() {
        return new Promise((resolve) => {
            resolve(this.data);
        });
    }

    /**
     * @method getUserEventsByDay
     * @param userId
     * @param date
     */
    public getUserEventsByDay(userId: string, date: string) {
        return new Promise(resolve => {
            let userResult: Array<{}> = this.data.filter((item) => {
                return (item['user_id'].indexOf(userId) > -1);
            });

            let user = userResult[0];

            if (user != undefined) {
                if (user['events'] != undefined) {
                    let oneDayEventsResult = user['events'].filter((item) => {
                        return (item['date'].indexOf(date) > -1);
                    });

                    let singleDay = oneDayEventsResult;

                    resolve(singleDay);
                } else {
                    resolve([]);
                }
            } else {
                resolve([]);
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/user-events/user-events.ts